import React from "react";
import { Modal } from "react-bootstrap";
import Text from "../Text";

export default (props) => {
  function onHide() {
    if (props.onHide) {
      props.onHide();
    }
  }
  return (
    <Modal show={props.show} onHide={onHide} size={props.size || "lg"}>
      <Modal.Header closeButton>
        <Modal.Title>
          <Text data-cy-test="#components-modal-title-text" fontSize="1em" color="primary">{props.title}</Text>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{props.children}</Modal.Body>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/_components/Modal/index.jsx